<mat-progress-bar
	mode="determinate"
	[value]="donation_progress_percentage"
></mat-progress-bar>
